/* @ngInject */
const myWagonDisplayTrains = () => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
      enableButtons: '=?',
    },
    template: require('./myWagonDisplayTrains.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.displayTrains = false

      $scope.toggleDisplay = () => {
        $scope.displayTrains = !$scope.displayTrains
      }
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}

export default myWagonDisplayTrains



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/display/myWagonDisplayTrains.js